import React, { useState, useEffect } from "react";
import { Button, Form, Tabs, Tab, Row, Col, Modal, Nav } from "react-bootstrap";

export const PreviewEmail = ({ show, setShow, formId, htmls }) => {

    const [counter, setcounter] = useState(0);

    const viewClose = () => setShow(false);
    const retFind = (viewForm, item, ans) => {
        const mp = new Map();
        viewForm?.pages?.forEach((itm) =>
            itm.sections?.forEach((ele) =>
                ele.questions?.forEach((i) => mp.set(i.questionName, i.value))
            )
        );
        let flag = [];
        item?.mainConditions?.forEach((ele) => {
            if (ele.condition == "AND") {
                if (ele.if == "All") {
                    let now = [];
                    ele.questions.forEach((i) => {
                        if (i.operator == "equals") {
                            now.push(i.values?.toString() == mp.get(i.name)?.toString());
                        } else if (i.operator == "not equals") {
                            now.push(i.values?.toString() != mp.get(i.name)?.toString());
                        } else if (i.operator == "in this list") {
                            now.push(
                                i.values
                                    .sort()
                                    ?.toString()
                                    .includes(mp.get(i.name).sort()?.toString())
                            );
                        } else if (i.operator == "not in this list") {
                            now.push(
                                !i.values
                                    .sort()
                                    ?.toString()
                                    .includes(mp.get(i.name).sort()?.toString())
                            );
                        }
                    });
                    if (now.length > 0) {
                        let x = true;
                        for (let i = 0; i < now.length; i++) {
                            x = x && now[i];
                        }
                        flag.push({ op: "AND", val: x });
                    }
                } else {
                    let now = [];
                    ele.questions.forEach((i) => {
                        if (i.operator == "equals") {
                            now.push(i.values?.toString() == mp.get(i.name)?.toString());
                        } else if (i.operator == "not equals") {
                            now.push(i.values?.toString() != mp.get(i.name)?.toString());
                        } else if (i.operator == "in this list") {
                            now.push(
                                i.values
                                    .sort()
                                    ?.toString()
                                    .includes(mp.get(i.name).sort()?.toString())
                            );
                        } else if (i.operator == "not in this list") {
                            now.push(
                                !i.values
                                    .sort()
                                    ?.toString()
                                    .includes(mp.get(i.name).sort()?.toString())
                            );
                        }
                    });
                    if (now.length > 0) {
                        let x = true;
                        for (let i = 0; i < now.length; i++) {
                            x = x && now[i];
                        }
                        flag.push({ op: "AND", val: x });
                    }
                }
            } else if (ele.condition == "OR" && flag[flag.length - 1] == false) {
                if (ele.if == "All") {
                    let now = [];
                    ele.questions.forEach((i) => {
                        if (i.operator == "equals") {
                            now.push(i.values?.toString() == mp.get(i.name)?.toString());
                        } else if (i.operator == "not equals") {
                            now.push(i.values?.toString() != mp.get(i.name)?.toString());
                        } else if (i.operator == "in this list") {
                            now.push(
                                i.values
                                    .sort()
                                    ?.toString()
                                    .includes(mp.get(i.name).sort()?.toString())
                            );
                        } else if (i.operator == "not in this list") {
                            now.push(
                                !i.values
                                    .sort()
                                    ?.toString()
                                    .includes(mp.get(i.name).sort()?.toString())
                            );
                        }
                    });
                    if (now.length > 0) {
                        let x = true;
                        for (let i = 0; i < now.length; i++) {
                            x = x || now[i];
                        }
                        flag.push({ op: "OR", val: x });
                    }
                } else {
                    let now = [];
                    ele.questions.forEach((i) => {
                        if (i.operator == "equals") {
                            now.push(i.values?.toString() == mp.get(i.name)?.toString());
                        } else if (i.operator == "not equals") {
                            now.push(i.values?.toString() != mp.get(i.name)?.toString());
                        } else if (i.operator == "in this list") {
                            now.push(
                                i.values
                                    .sort()
                                    ?.toString()
                                    .includes(mp.get(i.name).sort()?.toString())
                            );
                        } else if (i.operator == "not in this list") {
                            now.push(
                                !i.values
                                    .sort()
                                    ?.toString()
                                    .includes(mp.get(i.name).sort()?.toString())
                            );
                        }
                    });
                    if (now.length > 0) {
                        let x = true;
                        for (let i = 0; i < now.length; i++) {
                            x = x || now[i];
                        }
                        flag.push({ op: "OR", val: x });
                    }
                }
            }
        });
        for (let i = 0; i < flag.length; i++) {
            if (flag[i].op == "AND") ans = ans && flag[i].val;
            else ans = ans || flag[i].val;
        }
        if (flag.length > 0) return ans;
        else return false;
    };

    return (
        <Modal show={show} size="xl" onHide={viewClose} animation={false}>
            <Modal.Header closeButton>
                <Modal.Title>Form preview</Modal.Title>
            </Modal.Header>
            <Modal.Body className="global-tab">
                <Tabs
                    defaultActiveKey="desktop"
                    id="uncontrolled-tab-example"
                    className="mb-3 preview-tab"
                >
                    <Tab
                        eventKey="desktop"
                        title={
                            <span>
                                <span className="material-symbols-outlined display-icon mb-1">
                                    desktop_windows
                                </span>
                                Desktop
                            </span>
                        }
                    >
                        <div className="relative text-content">
                            <div className="display-img display-desktop text-center">
                                <img src="/assets/images/desktop-display.svg" alt="" />
                            </div>
                            <div className="display-view desktop-view">
                                <div className="p-4">
                                    <div dangerouslySetInnerHTML={{
                                        __html: htmls,
                                    }}></div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                    <Tab
                        eventKey="tablet"
                        title={
                            <span>
                                <span className="material-symbols-outlined display-icon mb-1">
                                    tablet_mac
                                </span>
                                Tablet
                            </span>
                        }
                    >
                        <div className="relative text-content">
                            <div className="display-img display-tablet text-center">
                                <img src="/assets/images/tablet-display.svg" alt="" />
                            </div>
                            <div className="display-view tablet-view">
                                <div className="p-4">
                                    <div dangerouslySetInnerHTML={{
                                        __html: htmls,
                                    }}></div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                    <Tab
                        eventKey="mobile"
                        title={
                            <span>
                                <span className="material-symbols-outlined display-icon mb-1">
                                    phone_iphone
                                </span>
                                Mobile
                            </span>
                        }
                    >
                        <div className="relative text-content">
                            <div className="display-img display-mobile text-center">
                                <img src="/assets/images/mobile-display.svg" alt="" />
                            </div>
                            <div className="display-view mobile-view">
                                <div className="p-4">
                                    <div dangerouslySetInnerHTML={{
                                        __html: htmls,
                                    }}></div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                </Tabs>
            </Modal.Body>
        </Modal>
    );
};
